import { JSX } from 'react';
import SwiperCore, { SwiperOptions } from 'swiper';
import { Container } from '@adobe/aem-react-editable-components';
import { TabsV1IsEmptyFn } from '@adobe/aem-core-components-react-spa';

import { TabsNavigation } from './tabs-navigation/tabs-navigation';
import { TabsContent } from './tabs-content/tabs-content';
import { TabsBase } from './tabs-base';
import { TabsProperties, TabsState } from './tabs.config';

const TABS_EFFECT_POSITION = 22;
const TABS_DEFAULT_EFFECT_CLASS = 'snowflake-tabs-effect-slide';

class Tabs extends TabsBase<TabsProperties, TabsState> {
  static defaultProps = {
    ...Container.defaultProps,
    autoHeight: true,
  };

  constructor(props: TabsProperties) {
    super(props);

    this.state = {
      ...this.state,
      swiper: null,
    };
  }

  componentDidUpdate(prevProps: Readonly<TabsProperties>): void {
    if (this.shouldUpdateActiveOnAuthorPanelSwitch(prevProps)) {
      const activeIndex = Number(this.props.activeIndexFromAuthorPanel);
      this.setState({ activeIndex });
      if (this.state.swiper) {
        this.state.swiper.slideTo(activeIndex);
      }
    }
  }

  setSwiper = (swiper: SwiperCore) => {
    this.setState({ swiper });
  };

  tabNavigation() {
    const childComponents: JSX.Element[] = [];

    if (!this.props.cqItems || !this.props.cqItemsOrder) {
      return childComponents;
    }

    return (
      <TabsNavigation
        cqItemsOrder={this.props.cqItemsOrder}
        activeItemId={this.state.activeIndex}
        setActiveItemId={this.setActiveTab}
        cqItems={this.props.cqItems}
        accessibilityLabel={this.props.accessibilityLabel}
        setSwiper={this.setSwiper}
      />
    );
  }

  render() {
    const isEmpty = TabsV1IsEmptyFn(this.props);

    const effectClass =
      this.props.appliedCssClassNames
        ?.split(' ')
        .find((appliedClass) => appliedClass.includes('snowflake-tabs-effect')) || TABS_DEFAULT_EFFECT_CLASS;

    const effect = effectClass.slice(TABS_EFFECT_POSITION) as SwiperOptions['effect'];

    return (
      <div aria-label={this.props.accessibilityLabel} data-testid="tabs" {...this.tabContainerProps}>
        {!isEmpty && this.tabNavigation()}
        {!isEmpty && (
          <TabsContent
            effect={effect}
            isInEditor={this.props.isInEditor}
            childComponents={this.childComponents}
            activeItemId={this.state.activeIndex}
            autoHeight={this.props.autoHeight}
          />
        )}
        {this.placeholderComponent}
      </div>
    );
  }
}

export default Tabs;
